import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import Table from 'rc-table'
import moment from 'moment'
import Dropdown from 'react-dropdown'

import { Divider, EInputTemplate, Input } from '../../components'
import { useTypedSelector, useValidation } from '../../hooks'
import { Assets } from '../../assets'
import {
  createCategoriesAdsAction,
  deleteCategoriesAdsAction,
  getCategoriesAdsAction,
  updateCategoriesAdsAction,
} from '../../store/categoriesAds'
import { Modal } from '../../components/Modal'
import { PhotoPicker } from '../../components/PhotoPicker'

import {
  Header,
  StyledHeader,
  StyledRow,
  StyledTable,
  TableWrapper,
  Title,
  StyledPagination,
  StyledButtonEnd,
  StyledButton,
  FullWidth,
  StyledEntity,
  Image,
  StyledSort,
  HeaderTitle,
  HeaderModal,
  FooterModal,
  ButtonCreate,
  ButtonDelete,
  ButtonUpdate,
  Close,
  NavigateButton,
  BodyModal,
  PhotoCategory,
  StyledWrapper,
  Error,
  ErrorBlock,
} from './styled'
import { PAGE_LiMIT } from './consts'

export const CategoriesTab = () => {
  const [typeModal, setTypeModal] = useState<string | null>(null)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [cateoriesArray, setCategoriesArray] = useState<any>([])
  const [searchPage, setSearchPage] = useState<number>(1)
  const [currentData, setCurrentData] = useState<any>(null)
  const [formData, setFormData] = useState<{
    titleUk: string
    titleEn: string
    photo: null | File
  }>({
    titleUk: '',
    titleEn: '',
    photo: null,
  })
  const languages = ['uk', 'en']

  const [language, setLanguage] = useState<string>('uk')

  const dispatch = useDispatch()

  const { totalCount, categoriesAds, response } = useTypedSelector(
    state => state.categories,
  )

  const schema = useMemo<any>(
    () => ({
      titleUk: {
        condition: !!formData.titleUk,
        error: 'Введите название на uk',
      },
      titleEn: {
        condition: !!formData.titleEn,
        error: 'Введите название на eng',
      },
      photo: {
        condition: !!formData.photo,
        error: 'Выберите фото',
      },
    }),
    [formData],
  )

  console.log(schema, 'schema')

  const {
    validationSchema,
    validation,
    enableValidation,
    isEnabled,
    disableValidation,
    //eslint-disable-next-line
  } = useValidation(schema)

  const columns = [
    {
      title: <div>Имя</div>,
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: <div>Фото</div>,
      dataIndex: 'image',
      key: 'image',
    },
    {
      title: (
        <StyledSort>
          <div>Дата создания</div>

          <Divider width={10} />
        </StyledSort>
      ),
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Подробнее',
      dataIndex: 'details',
      key: 'details',
    },
  ]

  const choosePage = (page: number) => {
    dispatch(
      getCategoriesAdsAction.request({
        page: page === 0 ? 1 : page,
        limit: PAGE_LiMIT,
        sortBy: '',
      }),
    )
    setCurrentPage(page === 0 ? 1 : page)
  }

  const putSearchPage = (e: React.SyntheticEvent<Element, Event> | any) => {
    setSearchPage(isNaN(+e.target.value) ? 1 : +e.target.value)
  }

  const enterKeyPress = (e: any) => {
    e?.code === 'Enter' &&
      choosePage(
        searchPage <=
          (totalCount === 0 ? 1 : Math.ceil(totalCount / PAGE_LiMIT))
          ? searchPage !== currentPage
            ? searchPage
            : 1
          : 1,
      )
  }

  const createCategories = async () => {
    enableValidation()
    await validation()

    const data = new FormData()

    if (formData.photo) {
      data.append('image', formData.photo)
    }
    if (formData.titleUk) {
      data.append(
        'title',
        JSON.stringify([
          { lang: 'uk', value: formData.titleUk },
          { lang: 'en', value: formData.titleEn },
        ]),
      )
    }

    dispatch(createCategoriesAdsAction.request({ data }))
    disableValidation()
  }

  const updateCategories = async () => {
    enableValidation()
    await validation()

    const data = new FormData()

    data.append(
      'title',
      JSON.stringify([
        { lang: 'uk', value: formData.titleUk },
        { lang: 'en', value: formData.titleEn },
      ]),
    )
    if (typeof formData.photo !== 'string') {
      data.append('image', formData.photo as File)
    }

    dispatch(updateCategoriesAdsAction.request({ id: currentData._id, data }))
    disableValidation()
  }

  const deleteCategories = () => {
    dispatch(deleteCategoriesAdsAction.request({ id: currentData._id }))
  }

  const handleInputChange = (e: any) => {
    const { value, name } = e.target as HTMLInputElement
    setFormData({ ...formData, [name]: value })
  }

  const handlePhotoChange = (file: File | null) => {
    setFormData({ ...formData, photo: file })
  }

  const getCategories = (name?: string) => {
    dispatch(
      getCategoriesAdsAction.request({
        page: currentPage === 0 ? 1 : currentPage,
        limit: PAGE_LiMIT,
        sortBy: 'createdAt',
      }),
    )
  }
  // eslint-disable-next-line
  useEffect(() => {
    getCategories()
  }, [])

  useEffect(() => {
    if (
      response === 'CREATE_CATEGORIES' ||
      response === 'UPDATE_CATEGORIES' ||
      response === 'DELETE_CATEGORIES'
    ) {
      setTypeModal('')
      setFormData({
        photo: null,
        titleUk: '',
        titleEn: '',
      })
      getCategories()
    }
  }, [response])

  const openCurrentCategory = (data: any) => {
    setTypeModal('update')
    setCurrentData(data)
  }

  const closeModal = () => {
    setTypeModal(null)
    setCurrentData(null)
    setFormData({
      photo: null,
      titleUk: '',
      titleEn: '',
    })
  }

  useEffect(() => {
    setCategoriesArray(
      categoriesAds?.map((c: any) => ({
        image: (
          <PhotoCategory
            src={`https://dev-petshealth.api.kitg.com.ua/public/ads-categories/${c?.image}`}
            alt="categories-image"
          />
        ),
        title: c?.title[0].value ?? '-',
        createdAt: moment(c?.createdAt).isValid()
          ? moment(c?.createdAt).format('HH:mm DD.MM.YYYY')
          : '-',
        key: c?.id,
        details: (
          <NavigateButton onClick={() => openCurrentCategory(c)}>
            Подробнее
          </NavigateButton>
        ),
      })),
    )
  }, [categoriesAds])

  useEffect(() => {
    if (currentData) {
      setFormData((prevState: any) => ({
        ...prevState,
        titleUk: currentData?.title[0]?.value,
        titleEn: currentData?.title[1]?.value,
        photo: `https://dev-petshealth.api.kitg.com.ua/public/ads-categories/${currentData?.image}`,
      }))
    }
  }, [currentData])

  const changeType = (type: string) => {
    setLanguage(type)
  }

  return (
    <>
      <div>
        <Header>
          <Title>{`Категории объвлений (${totalCount})`}</Title>
          <StyledPagination>
            <StyledEntity onKeyPress={enterKeyPress}>
              <Input
                label="Страница"
                name="searchPage"
                value={searchPage.toString()}
                placeholder="Страница"
                template={EInputTemplate.NAME}
                onChange={putSearchPage}
              />
            </StyledEntity>
            <Divider width={10} />
            <Image
              src={Assets.SEARCH_ICON}
              onClick={() =>
                choosePage(
                  searchPage <=
                    (totalCount === 0 ? 1 : Math.ceil(totalCount / PAGE_LiMIT))
                    ? searchPage
                    : 1,
                )
              }
            />
          </StyledPagination>
          <ButtonCreate onClick={() => setTypeModal('create')}>
            Создать
          </ButtonCreate>
        </Header>

        <Divider height={30} />

        <TableWrapper>
          <Table
            columns={columns}
            data={cateoriesArray}
            scroll={{ y: 650 }}
            components={{
              body: {
                row: StyledRow,
              },
              header: {
                cell: StyledHeader,
              },
              table: StyledTable,
            }}
          />
        </TableWrapper>

        <Divider height={20} />
      </div>

      <FullWidth>
        <StyledPagination>
          {currentPage === 1 ? (
            <StyledButtonEnd>Назад</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => choosePage(currentPage - 1)}>
              Назад
            </StyledButton>
          )}

          <div>
            {currentPage}/
            {!totalCount
              ? 1
              : Math.ceil(totalCount / PAGE_LiMIT) === 0
              ? 1
              : Math.ceil(totalCount / PAGE_LiMIT)}
          </div>

          {currentPage ===
          (!totalCount ? 1 : Math.ceil(totalCount / PAGE_LiMIT)) ? (
            <StyledButtonEnd>Далее</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => choosePage(currentPage + 1)}>
              Далее
            </StyledButton>
          )}
        </StyledPagination>
        <Divider height={10} />
      </FullWidth>
      {typeModal && (
        <Modal>
          <HeaderModal>
            <HeaderTitle>
              {typeModal === 'create'
                ? 'Создать Категорию'
                : 'Обновить категорию'}
            </HeaderTitle>
            <Close onClick={closeModal}>&#x2716;</Close>
          </HeaderModal>
          <BodyModal>
            <StyledWrapper>
              <Dropdown
                options={languages}
                onChange={option => changeType(option.value)}
                value={language}
                placeholder="Виберите язык"
              />
            </StyledWrapper>

            {language === 'uk' && (
              <Input
                label="Название - uk"
                name="titleUk"
                value={formData.titleUk}
                placeholder="Введите имя"
                template={EInputTemplate.NAME}
                onChange={handleInputChange}
              />
            )}
            <ErrorBlock>
              {!(!isEnabled || validationSchema.titleUk) && (
                <Error>{schema.titleUk.error}</Error>
              )}
            </ErrorBlock>
            {language === 'en' && (
              <Input
                label="Название - eng"
                name="titleEn"
                value={formData.titleEn}
                placeholder="Введите имя"
                template={EInputTemplate.NAME}
                onChange={handleInputChange}
              />
            )}
            <ErrorBlock>
              {!(!isEnabled || validationSchema.titleEn) && (
                <Error>{schema.titleEn.error}</Error>
              )}
            </ErrorBlock>
            <PhotoPicker
              width={415}
              height={150}
              onChange={handlePhotoChange}
              value={formData.photo ? formData.photo : undefined}
            />
            {!(!isEnabled || validationSchema.photo) && (
              <Error>{schema.photo.error}</Error>
            )}
          </BodyModal>
          <FooterModal>
            {typeModal === 'create' ? (
              <ButtonCreate onClick={createCategories}>Создать</ButtonCreate>
            ) : (
              <>
                <ButtonDelete onClick={deleteCategories}>Удалить</ButtonDelete>
                <ButtonUpdate onClick={updateCategories}>Обновить</ButtonUpdate>
              </>
            )}
          </FooterModal>
        </Modal>
      )}
    </>
  )
}
